<template>
  <div class="banner">
    <!-- tab商品页 -->
    <div class="tabBox">
      <div
        class="common tab1"
        style="border: 1px solid #4aa0e1; color: #4aa0e1"
        :class="{ active_1: currentTab === 2 }"
        @click="changeTab(2)"
      >
        {{ $t("shopList.phone") }}
      </div>
      <div
        class="common tab3"
        style="border: 1px solid #1cda48; color: #1cda48"
        :class="{ active_3: currentTab === 3 }"
        @click="changeTab(3)"
      >
        {{ $t("shopList.jiadian") }}
      </div>
      <div
        class="common tab2"
        style="border: 1px solid #c84e4e; color: #c84e4e"
        :class="{ active_2: currentTab === 1 }"
        @click="changeTab(1)"
      >
        {{ $t("shopList.jiu") }}
      </div>
    </div>
    <el-carousel class="swiper" :height="isMobile ? '100px' : '260px'">
      <el-carousel-item v-for="item in swiperList" :key="item.id">
        <img :src="item.imgSrc" style="width: 100%; height: 100%" />
      </el-carousel-item>
    </el-carousel>
    <div class="searchBox">
      <el-input
        style="width: 220px; margin-right: 4px"
        size="small"
        clearable
        prefix-icon="el-icon-search"
        v-model="searchValue"
      >
      </el-input>
      <el-button size="small" type="primary" plain @click="handleSearch">{{
        $t("shopList.search")
      }}</el-button>
    </div>

    <div class="iconBox">
      <h2 style="color: #343a40; font-size: 23px; font-weight: 600">
        人気買取商品
      </h2>
      <img src="../assets/productList/icon.png" alt="" />
<!--      <img
        src="../assets/productList/hot.jpg"
        style="width: 100%; margin: 20px 0"
        alt=""
      />-->
      <div class="desktop">
        <div style="display: flex; justify-content: space-between">
          <!-- <a @click="clickHot('',3)">
            ゲーム機
            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/2-android.png" alt="android-category">
          </a>
          <a @click="clickHot('',3)">
            Aplle
            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/2-android.png" alt="android-category">
          </a> -->
          <a @click="clickHot('パソコン',3)">
            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/apple.png" alt="android-category">
          </a>
          <a @click="clickHot('iPhone',2)">
            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/1-iphone.png" alt="iphone-category">
          </a>
          <a @click="clickHot('カメラ',3)">
            <!-- タブレット -->
            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/xiangji.png" alt="android-category">
          </a>
          <!-- <a @click="clickHot('',3)">
            イヤホン
            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/2-android.png" alt="android-category">
          </a>
          <a @click="clickHot('',3)">
            カメラ
            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/2-android.png" alt="android-category">
          </a> -->

<!--          <a @click="clickHotTV('tcl')">-->
<!--            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/5-tablet.png" alt="tablet-category">-->
<!--          </a>-->
          <a @click="clickHot('Nintendo Switch ',1)">
            <img style="width: 100%; margin: 20px 0" class="link-img" src="../assets/productList/game.png" alt="alcohol-category">
          </a>
        </div>
      </div>
    </div>
    <div class="mainList">
      <div class="listCategory" v-if="!isMobile">
        <ul class="listUl">
          <li
            v-for="item in brandDataList"
            :key="item"
            :class="{ activeLi: currentBrand == item }"
            @click="handleBrand(item)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="mobileBrand" v-else>
        <div
          class="brandTab"
          v-for="item in brandDataList"
          :key="item"
          @click="handleBrand(item)"
        >
          {{ item }}
        </div>
      </div>
      <!-- 商品列表 -->
      <div class="productListContainer" v-loading="loading">
        <div
          class="product"
          v-for="(item, index) in productArr"
          :key="item.id"
          :style="{
            'margin-right': !isMobile
              ? (index + 1) % 3 === 0
                ? '1px'
                : '3vw'
              : (index + 1) % 2 === 0
              ? '0'
              : '1vw',
          }"
        >
          <div class="productImgBox">
            <img :src="baseUrl + item.image" alt="" class="productImg" />
          </div>
          <div class="price">
            <div class="count">￥{{ item.price }}</div>
          </div>
          <div class="fanhao">
            <!-- {{ $t("shopList.mingcheng") }}：  -->
            {{ item.name }}
          </div>
          <div class="info">{{ item.title }}</div>
          <div class="tips">
            <el-popover
              placement="bottom"
              width="260"
              v-model="item.catgoryFlag"
              @show="showCatgory(item)"
            >
              <div>
                <div style="margin-bottom: 20px">
                  <el-select
                    v-model="item.secColor"
                    size="small"
                    style="width: 150px"
                    :placeholder="$t('shopList.color')"
                  >
                    <el-option
                      v-for="(i, k) in item.colorList"
                      :key="k"
                      :label="i"
                      :value="i"
                    >
                    </el-option>
                  </el-select>
                  <el-input-number
                    style="width: 100px; margin-left: 10px"
                    size="small"
                    :min="min"
                    v-model="item.secCount"
                  ></el-input-number>
                </div>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="info"
                    plain
                    @click="item.catgoryFlag = false"
                    >{{ $t("button.cancel") }}</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleSure(item)"
                    >{{ $t("button.sure") }}</el-button
                  >
                </div>
              </div>
              <img
                slot="reference"
                class="shareIcon"
                src="../assets/productList/catgory.png"
                alt=""
                style="margin-right: 20px"
              />
            </el-popover>
            <img
              class="shareIcon"
              src="../assets/productList/share.png"
              alt=""
              @click="handleShare(item)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shopList, addCategory, brandList } from "@/api/index";

export default {
  components: {},
  props: {},
  data() {
    return {
      swiperList: [
        {
          id: 1,
          imgSrc: require("../assets/swiper/banner_2.png"),
        },
        {
          id: 2,
          imgSrc: require("../assets/swiper/banner_1.png"),
        },
        {
          id: 3,
          imgSrc: require("../assets/swiper/banner_3.png"),
        },
      ],
      isMobile: false,
      baseUrl: "/proxyApi",
      proId: -1,
      currentTab: 2,
      searchValue: "",
      //商品列表数组
      productArr: [
        // {
        //   id: 1,
        //   price: "100.00",
        //   title: "华南虎",
        //   des: "25*20*10",
        //   imgSrc: require("../assets/productList/product.jpg"),
        //   catgoryFlag: false,
        //   count: 0,
        //   color: "",
        // },
        // {
        //   id: 2,
        //   title: "华南虎",
        //   des: "25*20*10 2CM",
        //   imgSrc: require("../assets/productList/product.jpg"),
        //   catgoryFlag: false,
        //   count: 0,
        //   color: "",
        // },
        // {
        //   id: 3,
        //   price: "100.00",
        //   title: "华南虎",
        //   des: "25*20*10 2CM",
        //   imgSrc: require("../assets/productList/product.jpg"),
        //   catgoryFlag: false,
        //   count: 0,
        //   color: "",
        // },
        // {
        //   id: 4,
        //   title: "华南虎",
        //   des: "25*20*10 2CM",
        //   imgSrc: require("../assets/productList/product.jpg"),
        //   catgoryFlag: false,
        //   count: 0,
        //   color: "",
        // },
      ],
      brandDataList: [],
      currentBrand: "",
      loading: false,
      // 购物车
      visible: false,
      min: 1,
    };
  },
  created() {
    this.isMobile = this.checkIfMobile();

    this.proId = window.location.search
      ? window.location.search.split("=")[1]
      : -1;
  },
  mounted() {
    this.getBrandList();
    this.initGetList();
  },
  methods: {
    getBrandList() {
      brandList({ category: this.currentTab })
        .then((res) => {
          console.log(res);
          this.brandDataList = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkIfMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileAgents = ["android", "iphone", "blackberry", "windows phone"];

      return mobileAgents.some((agent) => userAgent.includes(agent));
    },
    randomColor() {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    initGetList() {
      this.loading = true;
      shopList({
        name: this.searchValue,
        category: this.currentTab,
        id: this.proId,
        brand: this.currentBrand,
        status:"01"
      })
        .then((res) => {
          res.forEach((element) => {
            element.secColor = "";
            element.secCount = 1;
          });
          this.productArr = res;
          this.currentBrand = "";
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    handleSearch() {
      this.initGetList();
    },
    handleBrand(item) {
      this.currentBrand = item;
      this.initGetList();
    },
    clickHot(hostCategory,tabIndex){
      this.currentTab = tabIndex
      this.currentBrand = hostCategory;
      this.initGetList();
      this.getBrandList();
    },
    clickHotBeer(hostCategory){
      this.currentTab = hostCategory;
      this.initGetList();
      this.getBrandList();
    },
    changeTab(index) {
      this.currentTab = index;
      this.initGetList();
      this.getBrandList();
      // 当index为1、2、3时修改页面标题
      if (index === 1) {
        document.title = "ゲーム機";
      } else if (index === 2) {
        document.title = "携帯電話";
      } else if (index === 3) {
        document.title = "家電製品";
      }
    },
    // 分享
    handleShare(item) {
      let href = window.location.href + "?proId=" + item.id;
      if (navigator.clipboard && window.isSecureContext) {
        // 只能在安全域下使用 安全域包括本地访问与开启TLS安全认证的地址，如 https 协议的地址、127.0.0.1 或 localhost
        // navigator clipboard 向剪贴板写文本
        navigator.clipboard
          .writeText(href)
          .then(() => {
            this.$message({
              message: "共有リンクがクリップボードにコピーされました",
              type: "success",
            });
          })
          .catch((err) => {
            console.error("Failed to copy code: ", err);
          });
      } else {
        // 创建text area
        let textArea = document.createElement("textarea");
        textArea.value = href;
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = "absolute";
        textArea.style.opacity = 0;
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        return new Promise((res, rej) => {
          // 执行复制命令并移除文本框
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        })
          .then(() => {
            this.$message({
              message: "共有リンクがクリップボードにコピーされました",
              type: "success",
            });
          })
          .catch((err) => {
            console.error("Failed to copy code: ", err);
          });
      }
    },
    // 点击购物车
    showCatgory(item) {
      item.secCount = 1;
      item.secColor = "";
      item.catgoryFlag = true;
    },
    // 点击确定
    handleSure(item) {
      item.catgoryFlag = false;
      addCategory({
        spuId: item.id,
        count: item.secCount,
        color: item.secColor,
      }).then((res) => {
        if (res.code == -1) {
          this.$message({
            type: "error",
            message: res.message,
          });
          this.$router.push("/login");
        } else {
          this.$message({
            type: "success",
            message: res.message,
          });
        }
      });
    },

    //分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>
<style scoped lang="less">
.banner {
  width: 77vw;
  margin: 0px auto;
  padding: 20px 0;
  box-sizing: border-box;
}
.tabBox {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .common {
    width: 20vw;
    height: 35px;
    line-height: 35px;
    text-align: center;
    font-weight: 700;
    font-size: 15px;
    cursor: pointer;
  }
  .common:hover {
    color: #fff !important;
  }
  .tab1:hover {
    background-color: #4aa0e1;
    transition: all 0.8s;
  }
  .tab2:hover {
    background-color: #c84e4e;
    transition: all 0.8s;
  }
  .tab3:hover {
    background-color: #1cda48;
    transition: all 0.8s;
  }
}
.searchBox {
  text-align: right;
  margin-top: 30px;
  background: #f5f5f5;
  padding: 15px 10px;
}
.swiper {
  margin-top: 30px;
  // position: absolute;
  // width: 96%;
  // left: 50%;
  // transform: translateX(-50%);
  // top: 165px;
}
.active_1 {
  background-color: #4aa0e1 !important;
  color: #fff !important;
}
.active_2 {
  background: #c84e4e !important;
  color: #fff !important;
}
.active_3 {
  background: #1cda48 !important;
  color: #fff !important;
}

.iconBox {
  text-align: center;
  margin-top: 30px;
}
.mainList {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.productListContainer {
  width: 61vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 20px 0;
}
.product {
  width: 17.5vw;
  padding: 20px 10px 5px;
  text-align: center;
  margin-top: 20px;
  border: 2px solid #f5f5f5;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 2vw;
  box-sizing: border-box;
  .info {
    font-size: 15px;
    margin-top: 10px;
    height: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 4; //2表示行数，看自己需求设置超出多少行后出现...
    -webkit-box-orient: vertical;
  }
  @media screen and (max-width: 768px) {
    width: 14.5vw;    
  }
}

.product:hover {
  box-shadow: 0 0 10px 0 #81878e;
  transition: all 0.5s;
}
.productImgBox {
  // height: 100%;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
}

.productImg {
  width: 170px;
  height: 180px;
  @media screen and (max-width: 768px) {
    width: 100px;
    height: 80px;
    
  }
}
.price {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  background-color: #f5f5f5;
  margin-bottom: 10px;
  .count {
    font-size: 18px;
    color: #dc3545;
    font-weight: 700;
  }
}
.fanhao {
  font-size: 18px;
  @media screen and (max-width: 768px) {
    font-size: 14px;
    
  }
}
.tips {
  background: #f5f5f5;
  padding: 10px 0;
  margin-top: 10px;
  .shareIcon {
    width: 16px;
    height: 16px;
  }
}
.sortColor {
  color: orangered;
}
.pagesclass {
  margin: 0 auto;
  margin-top: 3%;
}
.listCategory {
  width: 15vw;
  min-height: 100px;
  margin-top: 20px;
  // border: 1px solid #81878e;
}
.listUl {
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    cursor: pointer;
    padding: 10px 30px;
    font-size: 14px;
    font-weight: 700;
    border-bottom: 1px solid #f5f5f5;
    box-sizing: border-box;
  }
  li:hover {
    color: #4aa0e1;
    background-color: #f5f5f5;
  }
}
.activeLi {
  color: #4aa0e1;
}
.mobileBrand {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.brandTab {
  padding: 5px 10px;
  font-size: 12px;
  border: 1px solid #f5f5f5;
  margin-right: 20px;
  margin-bottom: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
}

@media screen and (max-width: 768px) {
  .banner {
    width: 100vw;
    padding: 20px;
  }
  .swiper {
    // top: 135px;
  }
  .tabBox {
    .common {
      height: 25px;
      line-height: 25px;
      font-size: 12px;
    }
  }
  .searchBox {
    text-align: right;
    margin-top: 20px;
    background: none;
  }
  .iconBox {
    margin-top: 30px;
    h2 {
      font-size: 18px !important;
    }
  }
  .productListContainer {
    width: 100%;
    justify-content: space-between;
  }
  .product {
    width: 43vw;
    .info {
      height: 40px;
      font-size: 10px;
      -webkit-line-clamp: 3;
    }
  }
  .productImgBox {
    margin-bottom: 10px;
  }
  .price {
    padding: 5px 20px;
    .count {
      font-size: 13px;
    }
  }
  .fanhao {
    font-size: 10px;
  }
  .tips {
    padding: 5px 0;
    margin-top: 5px;
    .shareIcon {
      width: 12px;
      height: 12px;
    }
  }
  .mainList {
    display: block;
  }
}
@media all and (min-width: 768px) and (max-width: 1199px) {
  .banner {
    width: 95vw;
  }
  .tabBox {
    .common {
      height: 25px;
      line-height: 25px;
      font-size: 12px;
    }
  }
  .iconBox {
    margin-top: 30px;
    h2 {
      font-size: 18px !important;
    }
  }
  .productListContainer {
    width: 100%;

    justify-content: space-between;
  }
  .product {
    width: 34vw;
    // .info {
    //   height: 40px;
    //   font-size: 10px;
    //   -webkit-line-clamp: 3;
    // }
  }
  .productImgBox {
    margin-bottom: 10px;
  }
  .price {
    padding: 5px 20px;
    .count {
      font-size: 13px;
    }
  }
  .fanhao {
    font-size: 10px;
  }
  .tips {
    padding: 5px 0;
    margin-top: 5px;
    .shareIcon {
      width: 12px;
      height: 12px;
    }
  }
  .listCategory {
    width: 30vw;
    margin-right: 20px;
  }
}
</style>